import { useDirectDocumentBudgetContext } from "@/components/shared/direct-document-budget";

/** Narrow view of the budget for the persistence watcher. */
export function useDirectDocumentBudgetInvalidation() {
    const { invalidate } = useDirectDocumentBudgetContext();
    return { invalidate };
}
